// @flow
const GET_NP_SITES = 'admin/np/GET_NP_SITES';
const GET_NP_SITES_SUCCESS = 'admin/np/GET_NP_SITES_SUCCESS';
const GET_NP_SITES_FAIL = 'admin/np/GET_NP_SITES_FAIL';
const GET_NP_SERVER_STATUS = 'admin/np/GET_NP_SERVER_STATUS';
const GET_NP_SERVER_STATUS_SUCCESS = 'admin/np/GET_NP_SERVER_STATUS_SUCCESS';
const GET_NP_SERVER_STATUS_FAIL = 'admin/np/GET_NP_SERVER_STATUS_FAIL';

const DELETE_NP_SITE = 'admin/np/DELETE_NP_SITE';
const DELETE_NP_SITE_SUCCESS = 'admin/np/DELETE_NP_SITE_SUCCESS';
const DELETE_NP_SITE_FAIL = 'admin/np/DELETE_NP_SITE_FAIL';
const SET_NP_SITE_ENABLED = 'admin/np/SET_NP_SITE_ENABLED';
const SET_NP_SITE_ENABLED_SUCCESS = 'admin/np/SET_NP_SITE_ENABLED_SUCCESS';
const SET_NP_SITE_ENABLED_FAIL = 'admin/np/SET_NP_SITE_ENABLED_FAIL';

export {
  DELETE_NP_SITE,
  DELETE_NP_SITE_SUCCESS,
  DELETE_NP_SITE_FAIL,
  GET_NP_SITES,
  GET_NP_SITES_SUCCESS,
  GET_NP_SITES_FAIL,
  GET_NP_SERVER_STATUS,
  GET_NP_SERVER_STATUS_SUCCESS,
  GET_NP_SERVER_STATUS_FAIL,
  SET_NP_SITE_ENABLED,
  SET_NP_SITE_ENABLED_SUCCESS,
  SET_NP_SITE_ENABLED_FAIL,
};

export type NetPublishSite = {
  catalogId: string,
  catalogName: string,
  creationDate: string,
  enabled: boolean,
  galleryName: string,
  isPreview: boolean,
  siteName: string,
  siteId: string,
  urlName: string,
};

export type NetPublishServerStatus = {
  port?: string,
  siteBasePath?: string,
};

export type NetPublishState = {
  sites: NetPublishSite[],
  status: NetPublishServerStatus,
};

type DeleteSiteAction = {|
  type: 'admin/np/DELETE_NP_SITE',
  payload: { session: string },
|};

type DeleteSiteFailAction = {|
  type: 'admin/np/DELETE_NP_SITE_FAIL',
|};

type DeleteSiteSuccessAction = {|
  type: 'admin/np/DELETE_NP_SITE_SUCCESS',
|};

type GetSitesAction = {|
  type: 'admin/np/GET_NP_SITES',
  payload: { session: string },
|};

type GetSitesFailAction = {|
  type: 'admin/np/GET_NP_SITES_FAIL',
|};

type GetSitesSuccessAction = {|
  type: 'admin/np/GET_NP_SITES_SUCCESS',
  payload: NetPublishSite[],
|};

type GetNPServerStatusAction = {|
  type: 'admin/np/GET_NP_SERVER_STATUS',
  payload: { session: string },
|};

type GetNPServerStatusFailAction = {|
  type: 'admin/np/GET_NP_SERVER_STATUS_FAIL',
|};

type GetNPServerStatusSuccessAction = {|
  type: 'admin/np/GET_NP_SERVER_STATUS_SUCCESS',
  payload: NetPublishServerStatus,
|};

type SetNPSiteEnabledAction = {|
  type: 'admin/np/SET_NP_SITE_ENABLED',
  payload: { session: string, enabled: boolean },
|};

type SetNPSiteEnabledFailAction = {|
  type: 'admin/np/SET_NP_SITE_ENABLED_FAIL',
|};

type SetNPSiteEnabledSuccessAction = {|
  type: 'admin/np/SET_NP_SITE_ENABLED_SUCCESS',
|};

export type Action =
  | DeleteSiteAction
  | DeleteSiteFailAction
  | DeleteSiteSuccessAction
  | GetSitesAction
  | GetSitesFailAction
  | GetSitesSuccessAction
  | GetNPServerStatusAction
  | GetNPServerStatusFailAction
  | GetNPServerStatusSuccessAction
  | SetNPSiteEnabledAction
  | SetNPSiteEnabledFailAction
  | SetNPSiteEnabledSuccessAction;



// WEBPACK FOOTER //
// ./src/state/types/netPublishTypes.js